import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import Loader from 'srcReact/components/common2/Loader'
import MemberOverview from 'srcReact/components/common2/MemberOverview'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import RSVP from 'srcReact/components/common2/RSVP'
import SuspendSection from 'srcReact/components/common2/SuspendSection'
import Tabs from 'srcReact/components/common2/Tabs'
import Icon from 'srcReact/components/icons/Icon'
import { redirectToPage } from 'srcReact/helpers/history'
import { getFlaggedColor } from 'srcReact/helpers/utils'
import { checkNested, isEmpty } from 'srcReact/helpers/validator'
import { isWorkplaceManager } from 'srcReact/helpers/workplaceHelper'
import Feeds from '../Feeds'
import Header from '../Header'
import Medias from '../Medias'
import Members from '../Members'
import RecurringMixrs from '../RecurringMixrs'
import styles from './styles.module.scss'
import { mixrActions } from 'srcReact/Mixr/actions'
import { rsvpActions } from 'srcReact/components/common2/RSVP/actions'
import ReviewActionButton from 'srcReact/components/common2/ReviewActionButton'

function Layout({
  mixrId,
  isDesktop,
  isMixrNotOver,
  isMixrParticipant,
  isGoing,
  isGroupMember,
  isStaffMember,
  isOrganizer,
  isPrivateGroup,
  isSuggestedMixr,
  isWidgetsExpanded,
  totalActiveUsersCount,
  activeTab,
  feedIdToScroll,
  selectedTabFromUrl,
  setShowCancelMixrPopup,
  setActiveTab,
  setShowAddToCalendarPopup,
  setFeedIdToScroll,
  getThreeDotsOptions,
  selectParticipantsTab,
  handleAddCoorganizer,
  handleRemoveCoorganizer,
  handleReinstate,
  setIsSuspendModalOpen,
  handleAddToCalendar
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    alert,
    login: { user: loggedInUser },
    common: { isMobile, serverErrors: commonServerErrors, isNative, isTablet },
    rsvp: { loading: rsvpLoading, success: rsvpSuccess, error: rsvpError, data: rsvpData },
    mixr: { mixr },
    mixr: {
      mixr: { location: mixrLocation, createMixrType, recurrence, createMixrLoading },
      mainLoading,
      serverErrors,
      participants,
      users,
      participantsStats,
      staff,
      widgets,
      moderation_info,
      createdMixrId,
      createdMixrUrl
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (!rsvpLoading && rsvpSuccess && rsvpData) {
      dispatch(mixrActions.updateAttendanceFromRSVP(rsvpData))
      dispatch(rsvpActions.clearData())
    }
  }, [rsvpLoading, rsvpSuccess])

  const handleClick = () => {
    redirectToPage(`/0/event/${mixrId}/invite-members`, isNative)
  }

  const isUserAttended = () => {
    if (mixr && mixr.logged_user) {
      const { logged_user } = mixr
      return (
        logged_user.mixr_attending !== 'unknown' &&
        logged_user.mixr_attending !== 'none' &&
        logged_user.mixr_attending !== 'can_t_go'
      )
    }
  }

  const rightContent = (
    <div className={styles.rightSideActions}>
      {isMixrNotOver && mixr?.logged_user ? (
        <RSVP
          mixrId={mixrId}
          groupId={mixr?.group?.id}
          groupName={mixr?.group?.name}
          groupRole={mixr.logged_user.group_role}
          selectedUserAttending={mixr.logged_user.mixr_attending}
          groupAttending={mixr.logged_user.group_attending}
          mixrAttendingType={mixr.attending_type}
          withoutGroupAproval={mixr.logged_user.without_group_approval}
          isStatic={mixr.is_preview || mixr.status === 'cancelled'}
          isInvite={mixr.logged_user.is_invited === 1}
          invitedBy={mixr.logged_user.invited_by}
          isRecurrence={mixr.recurrence.type !== 'none'}
          recurrenceMixrAttending={mixr.logged_user.recurrence_mixr_attending}
        />
      ) : null}

      {isDesktop &&
        isMixrNotOver &&
        mixr?.status !== 'cancelled' &&
        ((isMixrParticipant && isGroupMember) || isGoing) && (
          <button
            onClick={mixr && !mixr.is_preview && handleClick}
            className={`${styles.inviteLink} ${mixr && mixr.is_preview && styles.inactiveButton}`}>
            <Icon name='send' /> {t('mixrHome.invite')}
          </button>
        )}

      {mixr && mixr.status === 'over' && isUserAttended() && (
        <div className={styles.attended}>{t('mixrHome.attended')}</div>
      )}

      {isDesktop && (isGroupMember || isGoing || isWorkplaceManager()) && (
        <ReactMenu
          // direction='left'
          isStatic={mixr && (mixr.is_preview || mixr.status === 'cancelled')}
          ariaLabel={t('formlabel.openMainMenu')}
          options={getThreeDotsOptions(
            mixr,
            t,
            isNative,
            setActiveTab,
            setShowAddToCalendarPopup,
            setShowCancelMixrPopup,
            isMobile,
            isStaffMember,
            isOrganizer,
            isGoing,
            participants,
            styles.customCSVStyle,
            setIsSuspendModalOpen,
            handleAddToCalendar
          )}
          menuButtonCSS={styles.moreOptions}
          menuCSS={styles.moreOptionsMenu}
        />
      )}
    </div>
  )
  return (
    <div
      className={`${styles.outerWrapper} ${isNative && styles.nativeOuterWrapper} ${
        isWidgetsExpanded && styles.outerWrapperWidgetExpanded
      } ${(mixr?.is_preview || mixr?.status === 'cancelled') && styles.outerWrapperWithPreview}`}>
      <div className={`${styles.mixrWrapper} ${isNative && styles.nativeMixrWrapper}`}>
        <React.Fragment>
          {/* here we are checking if mixr.name is empty for loader because it's a mandatory field and if its non-empty then
        it means mixr response is loaded */}
          {mainLoading || createMixrLoading || isEmpty(mixr?.name) ? (
            <Loader />
          ) : (
            <React.Fragment>
              {!isSuggestedMixr && (
                <RecurringMixrs
                  recurrence={mixr && mixr.recurrence}
                  currentMixrId={mixrId}
                  isActive={mixr && mixr.status !== 'over' && mixr.status != 'cancelled'}
                  isSuspended={moderation_info && moderation_info.is_suspended}
                  isStatic={
                    mixr && (mixr.is_preview || mixr.recurrence.is_parent_event == 1 || mixr.status === 'cancelled')
                  }
                  isPreview={mixr && mixr.is_preview}
                  options={getThreeDotsOptions(
                    mixr,
                    t,
                    isNative,
                    setActiveTab,
                    setShowAddToCalendarPopup,
                    setShowCancelMixrPopup,
                    isMobile,
                    isStaffMember,
                    isOrganizer,
                    isGoing,
                    participants,
                    styles.customCSVStyle,
                    setIsSuspendModalOpen,
                    handleAddToCalendar
                  )}
                />
              )}
              {moderation_info.is_suspended ? (
                <SuspendSection
                  objectType='mixr'
                  status={moderation_info.suspention_status}
                  handleReinstate={handleReinstate}
                  handleEdit={() => redirectToPage(`/0/${mixr.group.id}/edit-mixr/${mixr.id}`)}
                  instruction={moderation_info.suspension_message}
                  handleDelete={() => setShowCancelMixrPopup(true)}
                  mixrData={() => (
                    <div className={styles.groupDetails}>
                      <span className={styles.aboutGroup}>{t('mixrHome.posted')}</span>
                      <AnchorLink isNative={isNative} path={`/0/home/group/${mixr && mixr.group && mixr.group.id}`}>
                        {mixr && mixr.group && mixr.group.name}
                      </AnchorLink>
                    </div>
                  )}
                />
              ) : moderation_info.flagged_posts >= 1 ? (
                <ReviewActionButton
                  iconName='flag-icon'
                  text={t('moderationReport.flaggedContentItem', {
                    count: moderation_info.flagged_posts,
                    item: moderation_info.flagged_posts > 1 ? t('moderationReport.items') : t('moderationReport.item')
                  })}
                  color={getFlaggedColor(moderation_info.flagged_posts)}
                  handleClick={() => redirectToPage(`/0/moderation?tab=awaiting_review`, isNative)}
                />
              ) : null}
              {!(moderation_info && moderation_info.is_suspended) && (
                <MemberOverview
                  className={styles.membersOverview}
                  participants={participants}
                  organizers={staff}
                  selectParticipantsTab={selectParticipantsTab}
                  totalUserCount={totalActiveUsersCount}
                  organizerCSS={styles.memberOverviewOrganizer}
                  show={participants.length > 0}
                  handleAddCoorganizer={handleAddCoorganizer}
                  handleRemoveCoorganizer={handleRemoveCoorganizer}
                  type='mixr'
                  isMixrOver={!isMixrNotOver}
                  isStaffMember={isStaffMember}
                />
              )}
              {mixr && (
                <Header
                  mixr={mixr}
                  isMemberViewVisible={participants.length > 0}
                  isMobile={isMobile}
                  isDesktop={isDesktop}
                  setShowAddToCalendarPopup={mixr && !mixr.is_preview ? setShowAddToCalendarPopup : null}
                  isGoing={isGoing}
                  isSuspended={moderation_info && moderation_info.is_suspended}
                  handleAddToCalendar={handleAddToCalendar}
                />
              )}
              <Tabs
                initialActive={activeTab}
                className={`${styles.tabWrapper} ${participants.length > 1 ? styles.tabWrapper1 : styles.tabWrapper2} ${
                  moderation_info.is_suspended && 'elementWithSuspendedObject'
                }`}
                rightContent={rightContent}>
                <div
                  label={t('groupHome.tabs.feed')}
                  onClick={() => {
                    setActiveTab(0)
                  }}
                  iconName='feed'>
                  <Feeds
                    mixrId={mixrId}
                    isGroupVisible={isPrivateGroup ? isMixrParticipant : true}
                    isMemberOfGroup={isMixrParticipant}
                    isGroupOrganizer={isStaffMember}
                    isMixrOrganizer={isOrganizer}
                    feedIdToScroll={feedIdToScroll}
                    setFeedIdToScroll={setFeedIdToScroll}
                    setShowAddToCalendarPopup={setShowAddToCalendarPopup}
                    isGoing={isGoing}
                    isMixrNotOver={isMixrNotOver}
                    isStatic={mixr && (mixr.is_preview || mixr.status === 'cancelled')}
                    isDesktop={isDesktop}
                    handleAddToCalendar={handleAddToCalendar}
                  />
                </div>

                <div
                  label={`${t('mixrHome.members.participant')}${
                    mixr && checkNested(mixr, 'participants', 'going') && `(${mixr.participants.going.total})`
                  }`}
                  disabled={mixr.status === 'cancelled' ? true : isPrivateGroup ? !isMixrParticipant : false}
                  inactive={mixr && mixr.is_preview}
                  {...(!mixr.is_preview ? { onClick: () => setActiveTab(1) } : null)}
                  iconName='groups24'>
                  {!mixr.is_preview && (
                    <Members
                      mixrId={mixrId}
                      isStatic={mixr && (mixr.is_preview || mixr.status === 'cancelled')}
                      selectedScope={selectedTabFromUrl === 'leadership' ? 'staff' : ''}
                    />
                  )}
                </div>
                <div
                  disabled={mixr.status === 'cancelled' ? true : isPrivateGroup ? !isMixrParticipant : false}
                  inactive={mixr && mixr.is_preview}
                  label={t('groupHome.tabs.media')}
                  {...(!mixr.is_preview ? { onClick: () => setActiveTab(2) } : null)}
                  iconName='picture'>
                  {!mixr.is_preview && (
                    <Medias mixrId={mixrId} isStatic={mixr && (mixr.is_preview || mixr.status === 'cancelled')} />
                  )}
                </div>
              </Tabs>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    </div>
  )
}

export default Layout
